export default __webpack_public_path__ + "3d9825e04869764c3cc9ec5839ef7bea.png";